import React from 'react';
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../domain/controllers/ControllerContext';
import s from './CouponTotal.scss';
import classnames from 'classnames';

export enum CouponTotalDataHook {
  CouponTotalRoot = 'CouponTotal.CouponTotalRoot',
  CouponTotalLabel = 'CouponTotal.CouponTotalLabel',
  CouponTotalCode = 'CouponTotal.CouponCode',
  CouponTotalDiscountValue = 'CouponTotal.CouponDiscountValue',
}

export interface CouponTotalProps {
  shouldShowDivider?: boolean;
}

export const CouponTotal = ({shouldShowDivider = true}: CouponTotalProps) => {
  const {t} = useTranslation();
  const {isRTL} = useEnvironment();
  const {cartModel, estimatedTotals, fixFormattingOnRTL, sideCartCouponAndNote} = useControllerProps().cartStore;
  const appliedCoupon = estimatedTotals?.appliedCoupon || cartModel.appliedCoupon;
  const couponAmount =
    estimatedTotals?.priceSummary?.discount.formattedConvertedAmount ?? cartModel.discount.formattedConvertedAmount;

  const shouldShowDividerClass = (sideCartCouponAndNote && shouldShowDivider) || !sideCartCouponAndNote;

  return (
    <div
      data-hook={CouponTotalDataHook.CouponTotalRoot}
      className={shouldShowDividerClass && classnames(s.divider, s.root)}>
      <dl>
        <dt>
          <span data-hook={CouponTotalDataHook.CouponTotalLabel}>{t('cart.coupon')}</span>{' '}
          <span data-hook={CouponTotalDataHook.CouponTotalCode}>{appliedCoupon.code}</span>
        </dt>
        <dd
          className={fixFormattingOnRTL ? undefined : /* istanbul ignore next */ s.value}
          data-hook={CouponTotalDataHook.CouponTotalDiscountValue}
          data-wix-coupon-discount-value={CouponTotalDataHook.CouponTotalDiscountValue}>
          {fixFormattingOnRTL && isRTL ? /* istanbul ignore next */ `${couponAmount}-` : `-${couponAmount}`}
        </dd>
      </dl>
    </div>
  );
};
